import { Delete } from '@mui/icons-material';
import { Box, Button, Link, TableCell, TableRow } from '@mui/material';
import React, { useContext } from 'react';
import { Attachment } from '../../types/Attachment';
import { humanizeTimestamp } from '../../utility/dateUtils';
import { formatSize, getFileTypeIcon } from '../../utility/Attachment';
import { DisableContext } from '../../contexts/DisableContextProvider';

interface IAttachmentTileProps {
  attachment: Attachment;
  onDelete?: (key: string) => void;
}

export default function AttachmentTile({ attachment, onDelete }: IAttachmentTileProps) {
  const { disabled } = useContext(DisableContext);
  const { key, name, content_type, date, attached_by, size, url } = attachment;

  return (
    <TableRow key={key}>
      <TableCell>
        <Box>
          <Link color="inherit" href={url} target="blank" sx={{ display: 'flex', alignItems: 'center' }}>
            {getFileTypeIcon(content_type)}
            {name}
          </Link>
        </Box>
      </TableCell>
      <TableCell>{attached_by}</TableCell>
      <TableCell>{humanizeTimestamp(date)}</TableCell>
      <TableCell>{formatSize(size)}</TableCell>
      {
        onDelete && !disabled &&
        <TableCell>
          <Button onClick={() => onDelete(key)}>
            <Delete />
          </Button>
        </TableCell>
      }
    </TableRow>
  );
}
